import React from 'react';
import { Card, CardContent } from './ui/card';
import {
  ArrowRight
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { DEFAULT_PRODUCT_ICON_PATH, getProductIconSrcForProduct } from '../lib/productIcon';
import { solutionsPathForVendorSlug } from '../lib/vendorRoutes';

const ProductCard = ({
  product,
  linkTo,
  linkState,
  viewMode = 'grid',
  vendorCatalogSlug,
  centerContent = false,
}) => {
  const iconSrc = getProductIconSrcForProduct(product);
  const productLink = linkTo || `/product/${product.id}`;
  const isListView = viewMode === 'list';

  return (
    <Card className={`group relative bg-white border-border/50 hover:border-accent/50 transition-all duration-300 hover:shadow-lg hover:shadow-accent/5 cursor-pointer ${
      isListView ? 'h-auto' : 'h-full'
    }`}>
      <Link
        to={productLink}
        state={linkState}
        className="absolute inset-0 z-0 rounded-xl"
        aria-label={`Открыть ${product.name}`}
      />
      <CardContent className={`relative z-[1] pointer-events-none ${isListView ? 'p-4' : 'p-6'} flex flex-col h-full ${centerContent ? 'items-center text-center' : ''}`}>
        <div className={`${isListView ? 'w-40 h-40' : 'w-32 h-32'} rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden p-4 mb-4`}>
          <img
            src={iconSrc}
            alt=""
            className="w-full h-full object-contain"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = DEFAULT_PRODUCT_ICON_PATH;
            }}
          />
        </div>

        <div className={`flex flex-col flex-1 min-w-0 ${centerContent ? 'items-center w-full' : ''}`}>
          <div className={centerContent ? 'w-full' : undefined}>
            <h3 className={`${isListView ? 'text-lg sm:text-xl' : 'text-lg'} font-semibold mb-1 group-hover:text-accent transition-colors break-words`}>
              {product.name}
            </h3>
            {product.vendor && !centerContent && (
              <div className="mb-2 pointer-events-auto">
                <Link
                  to={vendorCatalogSlug ? solutionsPathForVendorSlug(vendorCatalogSlug) : '/solutions'}
                  className="inline-block text-base font-medium text-muted-foreground hover:text-accent transition-colors"
                  onClick={(e) => e.stopPropagation()}
                >
                  {product.vendor}
                </Link>
              </div>
            )}
            <p className={`text-sm text-muted-foreground ${isListView ? 'mb-3' : 'mb-4'} ${isListView ? '' : 'flex-grow'} break-words`}>
              {product.short_description || product.shortDescription}
            </p>
          </div>

          <div className={`${isListView ? 'flex flex-col gap-3' : 'pt-4 border-t border-border/50 space-y-3'} ${centerContent ? 'w-full' : ''}`}>
            <div className={`flex items-center ${centerContent ? 'justify-center gap-4 w-full' : 'justify-between'}`}>
              <span className="text-sm font-semibold text-accent whitespace-nowrap">{product.price || 'по запросу'}</span>
              <span className="inline-flex items-center gap-1 text-xs text-foreground group-hover:text-accent whitespace-nowrap">
                Подробнее
                <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
          </div>
          </div>
        </CardContent>
      </Card>
  );
};

export default ProductCard;
